import { Avatar } from '@/components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { guildActions } from '@/store/features';
import { useDispatch } from 'react-redux';
import { useProfile } from '@/hooks';
import { ClanWithStatsDtoRead } from '@/store/services/MidleNestApi.service';

type Props = ClanWithStatsDtoRead & {
  page: number;
  limit: number;
  order: number;
  mode?: string;
};

export default function ClansList({
  id,
  name,
  avatar,
  leaderboardActivity,
  membersCount,
  isJoinRequestSent,
  page,
  limit,
  order,
  mode,
}: Props) {
  const { t } = useTranslation();

  const {
    profile: { id: userId, clan },
  } = useProfile();

  const dispatch = useDispatch();

  const guild = React.useMemo(() => clan, [clan]);

  const openGuildJoinModal = React.useCallback(
    ({ guildId, guildName }: { guildId: string; guildName: string }) =>
      dispatch(guildActions.setJoinModal({ guildId, guildName, show: true })),
    [dispatch],
  );

  const avgXPPerDay = leaderboardActivity
    ? Math.round(leaderboardActivity?.totalXp / (leaderboardActivity?.hours / 24))
    : 0;

  return (
    <tr className='text-center text-sx sm:text-sm text-gray-600 dark:text-white'>
      <td className='hidden sm:table-cell'>{order + 1 + (page - 1) * limit}</td>
      <td className='py-6 flex gap-x-4 items-center text-left'>
        <div className=''>
          <Avatar name={String(name)} src={avatar?.src} className='h-10 w-10' />
        </div>{' '}
        {id ? <Link to={`/clans/${id}`}>{name}</Link> : <span>{name}</span>}
      </td>
      <td className='hidden md:table-cell'>{leaderboardActivity?.activityRating || '-'}</td>
      <td className='hidden sm:table-cell '>{avgXPPerDay || '-'}</td>
      <td className=''>{leaderboardActivity?.totalXp || '-'}</td>
      <td className='hidden sm:table-cell'>{membersCount || '-'}</td>
      {id && !guild && !mode && (
        <td className=''>
          <button
            type='button'
            className='px-6 py-2 rounded-lg text-sm text-blue-500 border border-blue-500 disabled:bg-blue-500 disabled:text-white disabled:opacity-50 disabled:px-2 dark:border-[#FFDA68] dark:text-[#FFDA68]'
            disabled={isJoinRequestSent}
            onClick={() =>
              openGuildJoinModal({
                guildId: id as string,
                guildName: name as string,
              })
            }
          >
            {isJoinRequestSent ? t('Request Sent') : t('Join')}
          </button>
        </td>
      )}
      {id && !guild && mode === 'invites' && (
        <td className=''>
          <Link
            className='px-4 py-1 rounded-md text-sm text-white bg-blue-400 disabled:grayscale'
            to={`/clans/${id}`}
          >
            {t('View')}
          </Link>
        </td>
      )}
      {id && !guild && mode === 'join-requests' && (
        <td className=''>
          <Link
            className='px-4 py-1 rounded-md text-sm text-white bg-blue-400 disabled:grayscale'
            to={`/clans/${id}`}
          >
            {t('View')}
          </Link>
        </td>
      )}
    </tr>
  );
}
